import { Box, Chip, Typography } from '@mui/material';
import { Business, ChevronRight } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { GET_LICENSES_WHERE_IS_ADMIN } from '../user.graphql';
import { Card } from './Card';
import { tokens } from './tokens';
import LoadingSpinner from '../../components/LoadingSpinner';

interface AdminLicense {
  id: number;
  companyName?: string | null;
}

interface Props {
  userId: number;
  onCount?(count: number): void;
}

export function AdminLicensesPanel({ userId }: Props) {
  const { loading, error, data } = useQuery<{ licenses: AdminLicense[] }>(GET_LICENSES_WHERE_IS_ADMIN, { variables: { id: userId } });

  const licenses = data?.licenses ?? [];

  if (!loading && !error && licenses.length === 0) return null;

  return (
    <Card
      title="Administrerer"
      action={
        <Chip
          size="small"
          label={licenses.length}
          sx={{
            background: tokens.primaryTint,
            color: tokens.primaryDark,
            fontWeight: 600,
            height: 22,
            borderRadius: 999,
          }}
        />
      }
      noBodyPadding>
      {loading && (
        <Box sx={{ p: 3 }}>
          <LoadingSpinner />
        </Box>
      )}
      {error && (
        <Box sx={{ p: 3 }}>
          <span>Feil! {error.message}</span>
        </Box>
      )}
      {licenses.map((lic, i) => (
        <Box
          key={lic.id}
          component={Link}
          to={`/license/${lic.id}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            padding: { xs: '12px 16px', sm: '14px 24px' },
            borderTop: i === 0 ? 'none' : `1px solid ${tokens.divider}`,
            color: tokens.text,
            textDecoration: 'none',
            transition: 'background 120ms ease',
            '&:hover': { background: tokens.surfaceAlt },
          }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: '6px',
              background: tokens.primaryTint,
              color: tokens.primaryDark,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}>
            <Business sx={{ fontSize: 18 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 500, color: tokens.primaryDark }}>
              {lic.companyName || '<Mangler navn>'}
            </Typography>
          </Box>
          <ChevronRight sx={{ fontSize: 16, color: tokens.textDisabled }} />
        </Box>
      ))}
    </Card>
  );
}
